import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { LegalPage, LegalSection } from '@/components/generals/legal'

const Barrierefreiheit: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Barrierefreiheit'
                description='Erklärung zur Barrierefreiheit der Website der Gashi Holding GmbH und wie Sie uns Barrieren melden können.'
                path='/barrierefreiheit'
            />

            <LegalPage
                title='Barrierefreiheit'
                updated='November 2026'
                intro='Unsere Website soll für alle Menschen gut nutzbar sein, unabhängig davon, ob sie mit Maus, Tastatur, Screenreader oder Vergrößerung arbeiten.'
            >
                <LegalSection title='Unser Anspruch'>
                    <p>
                        Wir orientieren uns an den Web Content Accessibility Guidelines (WCAG) 2.2 auf Stufe AA. Dazu gehören eine klare Überschriftenstruktur, ausreichende Farbkontraste, sichtbare Fokusmarkierungen, eine vollständige Bedienbarkeit per Tastatur sowie reduzierte Animationen für alle, die in ihrem System weniger Bewegung eingestellt haben.
                    </p>

                    <p>
                        Eine vollständige Prüfung durch eine unabhängige Stelle hat bisher nicht stattgefunden. Wir verbessern die Website laufend.
                    </p>
                </LegalSection>

                <LegalSection title='Barriere gefunden?'>
                    <p>
                        Wenn Ihnen etwas auffällt, das Sie bei der Nutzung einschränkt, schreiben Sie uns bitte über unser <Link href='/#kontakt'>Kontaktformular</Link>. Beschreiben Sie kurz, auf welcher Seite und bei welchem Inhalt die Barriere auftritt. Wir kümmern uns darum.
                    </p>
                </LegalSection>
            </LegalPage>
        </Layout>
    )
}

export default Barrierefreiheit
